"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _get = require("../../utils/get");

var _ContextProps = require("../../types/ContextProps");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IDs = {
  SITE_NAME: 'site.name',
  INDEX_SITE: 'site.index',
  INDEX_PAGE: 'page.index',
  NAME: 'category.name',
  DESCRIPTION: 'category.description',
  IMAGE: 'category.image',
  CATEGORY_PAGE_URL: 'category.url'
};
var userVisible = [];
var keysMetaData = Object.values(IDs).reduce(function (acc, val) {
  var _objectSpread2;

  return _objectSpread({}, acc, (_objectSpread2 = {}, _objectSpread2[val] = {
    userVisibility: userVisible.includes(val)
  }, _objectSpread2));
}, {});
var _default = {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.SITE_NAME] = (0, _get.get)(item, "context." + _ContextProps.CONTEXT_PROPS.SITE_NAME), _ref[IDs.INDEX_SITE] = (0, _get.getRawValue)(item, "context." + _ContextProps.CONTEXT_PROPS.INDEX_SITE), _ref[IDs.INDEX_PAGE] = (0, _get.getRawValue)(item, "context." + _ContextProps.CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.NAME] = (0, _get.get)(item, 'category.title'), _ref[IDs.DESCRIPTION] = (0, _get.get)(item, 'category.description'), _ref[IDs.IMAGE] = !!(0, _get.getRawValue)(item, 'category.images') ? (0, _get.getRawValue)(item, 'category.images')[0].src : '', _ref[IDs.CATEGORY_PAGE_URL] = (0, _get.get)(item, 'category.refersTo'), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {},
  getBiData: function getBiData() {},
  getKeys: function getKeys() {
    return Object.values(IDs).map(function (key) {
      return _objectSpread({
        key: key
      }, keysMetaData[key]);
    });
  }
};
exports["default"] = _default;